/**
 * 発電販売計画マスタの編集ダイアログを開いた時の、BG 情報・発電所情報の行の並び (電源ユニットマスタ 2a)。
 *
 * 付け替えで同じ系統コードの行が増えるので、離れて並ばないよう保存済みの行を昇順に並べてフォームへ入れる。
 * 並べるのはフォームを読み込んだ時だけ (入力中の行の追加・変更では並べ替えない = 触っている行が動かない)。
 *   BG 情報 = BG コード → 適用開始日 / 発電所情報 = 系統コード → 所属 BG コード → 適用開始日
 */
import { type CivilDate, compareCivilDate } from '~/models/civilDate'

const compareCode = (a: string, b: string): number =>
  a < b ? -1 : a > b ? 1 : 0

/** 適用開始日が無い行は最後に回す。 */
const compareFrom = (
  a: CivilDate | undefined,
  b: CivilDate | undefined,
): number => {
  if (a === undefined || b === undefined) {
    return a === b ? 0 : a === undefined ? 1 : -1
  }
  return compareCivilDate(a, b)
}

export const sortBgRowsForEdit = <
  T extends { bgMasterId: string; validFrom?: CivilDate },
>(
  rows: readonly T[],
  bgCodeById: ReadonlyMap<string, string>,
): T[] =>
  [...rows].sort(
    (a, b) =>
      compareCode(
        bgCodeById.get(a.bgMasterId) ?? a.bgMasterId,
        bgCodeById.get(b.bgMasterId) ?? b.bgMasterId,
      ) || compareFrom(a.validFrom, b.validFrom),
  )

export const sortPlantRowsForEdit = <
  T extends { plantCode: string; bgCode: string; validFrom?: CivilDate },
>(
  rows: readonly T[],
): T[] =>
  [...rows].sort(
    (a, b) =>
      compareCode(a.plantCode, b.plantCode) ||
      compareCode(a.bgCode, b.bgCode) ||
      compareFrom(a.validFrom, b.validFrom),
  )
